import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import settings from "@src/settings";
import { down } from "styled-breakpoints";
import getGridHeight from "@src/utils/getGridHeight";

export const Frame = styled.div<{ onClick: () => void }>`
	background-color: #fff;
	overflow: hidden;
	transition: 0.3s 0s linear;
	&:hover {
	 background-color: #FAFAFA;
	}
`;
export const Arrow = styled(motion.svg)`
	width: 27px;
	height: 18px;
`;
export const TitleRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 100px;
	padding: 0 52px;
	position: relative;
	cursor: pointer;
	${down("xs")} {
		padding: 0 27px;
		height: 72px;
	}
`;
export const TitleUnderLine = styled(motion.hr)`
	position: absolute;
	bottom: 0;
	left: 52px;
	right: 52px;
	border: none;
	border-bottom: 2px solid ${settings.color.main};
	${down("xs")} {
		left: 27px;
		right: 27px;
	}
`;
export const Title = styled.p`
	font-weight: 700;
	font-style: normal;
	font-family: ${settings.font.jp};
	color: ${settings.color.main};
	font-size: 18px;
	letter-spacing: 0.2857px;
	line-height: 100%;
`;
export const Content = styled(motion.div)`
	padding: 52px;
	cursor: pointer;
	${down("md")} {
		padding: 27px;
	}
`;
export const Data = styled(motion.dl)`
	display: flex;
	font-family: ${settings.font.jp};
	font-size: 16px;
	color: ${settings.color.main};
	line-height: 2;
	letter-spacing: 1.76px;
	white-space: pre-line;
	& + * {
		margin-top: 52px;
		padding-top: 52px;
		border-top: 2px solid ${settings.color.pale};
	}
	${down("md")} {
		display: block;
		& + * {
			margin-top: ${getGridHeight({ rows: 1 })}px;
			padding-top: ${getGridHeight({ rows: 1 })}px;
		}
	}
`;
export const DataTitle = styled.dt`
	flex: 0 0 16rem;
	font-weight: 700;
	margin-right: 1rem;
`;
export const DataDetail = styled.dd`
	flex: 1 1 auto;
	font-weight: 400;
`;
